import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { ApolloClient } from "apollo-client";
import { ApolloProvider } from "react-apollo";
import { InMemoryCache, defaultDataIdFromObject } from "apollo-cache-inmemory";
import { HttpLink } from "apollo-link-http";
import { ApolloLink } from "apollo-link";

import { SessionContextProvider } from "./context/SessionContext";
import { UIProvider } from "./context/UIContext";

const cache = new InMemoryCache({
  dataIdFromObject: object => {
    switch (object.__typename) {
      // TODO: update when fixed -> https://github.com/apollographql/react-apollo/issues/2202
      case "TimeSliceRaster":
        return `(Time Slice Raster) ${object.dataSource.id || "unknown"}:${
          object.variable.id
        }:${object.instant}:${object.leadTime}:${object.srid}`;
      case "DataGroup":
        return `(Data Group) ${object.name}`;
      case "DataSource":
        return `(Data Source) ${object.name}`;
      case "Variable":
        return `(Variable) ${object.name}`;
      default:
        return defaultDataIdFromObject(object);
    }
  }
});

const wexLink = new HttpLink({
  uri: "https://wex.sofarocean-test.com/graphql"
});
const wexGeoLink = new HttpLink({
  uri: "https://wex.sofarocean-test.com/geospatialgraphql"
});

// https://www.loudnoises.us/next-js-two-apollo-clients-two-graphql-data-sources-the-easy-way/
const client = new ApolloClient({
  cache,
  link: ApolloLink.split(
    operation => operation.getContext().clientName === "wex",
    wexLink,
    wexGeoLink
  ),
  fetchOptions: { mode: "no-cors" }
});

ReactDOM.render(
  <SessionContextProvider>
    <UIProvider>
      <ApolloProvider client={client}>
        <App />
      </ApolloProvider>
    </UIProvider>
  </SessionContextProvider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
